import _ from "lodash";
import {toGermanFormat} from "../../../../../utils/numberFormater";

export function maxSRRI(assets) {
  const maxItem = assets && _.maxBy(assets, i => i.sri);
  return maxItem && maxItem.sri || '-';
}

export function avgSRIValue(assets) {
  let totalWeight = 0, totalWeightedSRRI = 0;
  (assets || []).forEach(i => {
    if (!i.sri) return;

    const weight = parseFloat(i.weight);
    if (weight) {
      totalWeightedSRRI += i.sri * weight;
      totalWeight += weight;
    }
  });
  return totalWeight ? totalWeightedSRRI / totalWeight : null;
}

export function avgSRRI(assets) {
  const avgValue = avgSRIValue(assets);
  if(!_.isNull(avgValue)){
    return toGermanFormat(avgValue);
  } else {
    return '-';
  }
}